import createSagaMiddleware from 'redux-saga';
import { configureStore } from '@reduxjs/toolkit';
import {rootReducer} from './reducers/rootReducer';
import sagaInitiator from './sagas';
export * from './actions'
export * from './types'
export * from './selectors'
export * from './reducers'

//https://redux-toolkit.js.org/tutorials/typescript

const sagaMiddleware = createSagaMiddleware();

const reduxStore = configureStore({
  reducer: rootReducer,
  middleware: [sagaMiddleware],
});
sagaInitiator(sagaMiddleware);
export default reduxStore;
